export class WebViewBridgeV1 {
  get appInfo() {
    var _a, _b, _c, _d, _e;
    if (this.isBridgeAvailable()) {
      const injectedJSONString = (_b = (_a = window === null || window === void 0 ? void 0 : window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.injectedObjectJson) === null || _b === void 0 ? void 0 : _b.call(_a);
      if (injectedJSONString) {
        const injectedJSON = JSON.parse(injectedJSONString);
        return {
          osVersion: (_c = injectedJSON.appOSVersion) !== null && _c !== void 0 ? _c : 'unknown',
          os: (_d = injectedJSON.appPlatform) !== null && _d !== void 0 ? _d : 'unknown',
          version: (_e = injectedJSON.appVersion) !== null && _e !== void 0 ? _e : 'unknown'
        };
      }
    }
    return undefined;
  }
  get securityHeader() {
    var _a, _b;
    if (this.isBridgeAvailable()) {
      const injectedJSONString = (_b = (_a = window === null || window === void 0 ? void 0 : window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.injectedObjectJson) === null || _b === void 0 ? void 0 : _b.call(_a);
      if (injectedJSONString) {
        const injectedJSON = JSON.parse(injectedJSONString);
        if (injectedJSON.securityHeader) {
          return injectedJSON.securityHeader;
        }
      }
    }
    return undefined;
  }
  isBridgeAvailable() {
    var _a;
    return Boolean((_a = window === null || window === void 0 ? void 0 : window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.postMessage);
  }
  initiateAuth() {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'INITIATE_AUTH'
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  initiateRequestToken() {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'REQUEST_TOKEN'
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  initiateOpenPDP(url) {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'OPEN_PDP',
        payload: {
          url
        }
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  initiateOpenMapApp(address) {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'OPEN_MAP',
        payload: {
          url: `https://www.google.com/maps/search/?api=1&query=${address}`
        }
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  initiateOpenFAQInApp(url) {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'OPEN_FAQ',
        payload: {
          url
        }
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  notifyIntentToOpenBottomSheet(id) {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'OPENING_BOTTOM_SHEET',
        payload: {
          id
        }
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  notifyIntentToCloseBottomSheet(id) {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'CLOSING_BOTTOM_SHEET',
        payload: {
          id
        }
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  notifyIntentToShowOverlay() {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'SHOWING_OVERLAY'
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  notifyIntentToHideOverlay() {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'HIDING_OVERLAY'
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  notifyIntentToLogout() {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'INITIATE_LOGOUT'
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  notifyIntentToAddToCalendar(payload) {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'ADD_TO_CALENDAR',
        payload
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  notifyIntentToOpenWhatsapp(url) {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'OPEN_LIMEHOME_SUPPORT_WHATSAPP',
        payload: {
          url
        }
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  notifyIntentToNavigateTo(payload) {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'NAVIGATE_TO',
        payload
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  notifyCheckinCompleted() {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'CHECKIN_COMPLETED'
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  notifyBookingCompleted() {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'BOOKING_COMPLETED'
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  notifyIntentToOpenInAppBrowser(url) {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'OPEN_IN_APP_BROWSER',
        payload: {
          url
        }
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  sendCheckoutPageParams(params) {
    if (this.isBridgeAvailable()) {
      window.ReactNativeWebView.postMessage(this.getPayload({
        type: 'CHECKOUT_PAGE_PARAMS',
        payload: params
      }));
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }
  openUrlInBrowser(url) {
    return this.notifyIntentToOpenInAppBrowser(url);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  preventNavigateBack(_value) {
    return Promise.resolve(false);
  }
  getPayload(message) {
    return JSON.stringify(message);
  }
}